var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdicionar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.5,11.63c-14.29,0-25.87,11.58-25.87,25.87s11.58,25.87,25.87,25.87,25.87-11.58,25.87-25.87-11.58-25.87-25.87-25.87Zm12.02,28.61h-9.24v9.31h-5.55v-9.31h-9.25v-5.55h9.25v-9.24h5.55v9.24h9.24v5.55Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdicionar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ADICIONAR.be2aa30ae6930ca993a028e4ea073095.svg";